// handles product brief display on different resolutions
import * as React from 'react';
import { IProductBriefCollectionWrapper, ProductBriefCollection } from './ProductBriefCollection';
import { Breakpoints } from 'elc-base-theme';
import { Desktop, Mobile } from 'elc-layouts';

export class ProductBriefCollectionWrapper extends React.Component<IProductBriefCollectionWrapper> {
    public render() {
        return (
            <>
                <Desktop minWidth={Breakpoints.desktop}>
                    {() => <ProductBriefCollection {...this.props} isMobile={false} />}
                </Desktop>
                <Mobile maxWidth={Breakpoints.desktop - 1}>
                    {() => <ProductBriefCollection {...this.props} isMobile />}
                </Mobile>
            </>
        );
    }
}
